// 导入图表组件国际化
import echartsfn from "./echartsfn.js";

// 主登录页面内容
const main = {
  // 页面标题和欢迎信息
  title: "进入系统",
  Platformcount: "平台数据统计",
  PlatformcountUnit: "亿",
  tagtotal: "标签总量",
  malicetag: "恶意标签",
  Entitytag: "实体标签",
  behaviortag: "行为标签",
  Maliciousmonitoring: "恶意地址风险监控",
  TransferTrend: "恶意地址转账趋势图",
};

// 币种数据页面内容
const currencydata = {
  // 页面标题
  coinDataTitle: "币种数据",
  coinDataUnit: "(单位：USDT)",
  todayTransactionTitle: "今日大额交易监测",
  exchangeRankingsTitle: "交易所24小时成交额排行榜",

  // 数据标签
  priceLabel: "价格",
  tradingVolumeLabel: "交易总量",
  tradingAddressLabel: "交易地址",

  // 表格表头
  rankLabel: "排名",
  exchangeLabel: "交易所",
  volume24hLabel: "24H成交额($)",
  supportedCoinsLabel: "支持交易币种",

  // 状态提示
  // loadingText: "拼命加载中",
  // noDataText: "暂无数据",

  // 交易描述
  transferText: "转",
  toText: "至",
  transferToText: "转到",
};

// 图链安全页面内容
const graphSecurity = {
  // 页面标题
  graphSecurityTitle: "图链安全",
  labReportTitle: "实验室研究报告",

  // 标签页
  phishingFraudTab: "钓鱼诈骗",
  multiSignFraudTab: "多签诈骗",

  // 图表标题
  fraudAddressCountTitle: "钓鱼诈骗受害者地址数量",
  fraudAmountStatTitle: "被骗金额统计",
  victimAddressCountTitle: "受害者地址数量",
  fraudFeeAddressActiveTitle: "诈骗手续费地址活跃",

  // 单位
  addressCountUnit: "个",
  amountUnit: "万 USDT",

  // 报告标题
  phishingReportTitle: "钓鱼诈骗报告",
  multiSignReportTitle: "多签授权诈骗报告",

  // 报告描述
  phishingReportDesc:
    "图链安全实验室对波场（Tron）链上多签授权诈骗进行调查和披露，揭示诈骗团伙的具体作案手法，希望能为公众提供安全警示与建议。",
  multiSignReportDesc:
    "图链安全实验室通过对区块链钓鱼诈骗数据监测以及深入分析，我们发现攻击者利用高度相似地址伪装真实地址的手法越来越狡猾，使得用户在转账时容易产生误判，导致资产的损失。",
};

// 地图页面内容
const mapPage = {
  // 案件统计标签
  caseJudgmentCountLabel: "[判例数量]",
  indictmentCountLabel: "[起诉书数量]",

  // 数据说明
  incompleteStatisticsTitle: "数据不完全统计",
};

export default {
  ...main,
  ...currencydata,
  ...graphSecurity,
  ...mapPage,
  ...echartsfn,
  // 子模块
};
